import { Modal, Form, Input, Button, Col, Row, notification, DatePicker } from 'antd';
import store from '../../../../../controllers/store';
import { useSelector } from 'react-redux';
import { create } from '../../../../../controllers/store/actions/groups/create-group-action';
import { Actor, GroupRaw } from '../../../..';
import SelectCities from '../../Elements/Select-Cities';
import SelectKnowledgeArea from '../../Elements/Select-Knowledge-Area';
import SelectKnowledgeSpecialty from '../../Elements/Select-Knowledge-Specialty';
import SelectKnowledgeGran from '../../Elements/Select-Knowledge-Gran';
import SelectRecognition from '../../Elements/Select-Recognize';
import TextArea from 'antd/es/input/TextArea';
import SelectUniversity from '../../Elements/Select-University';

interface Props {
    loading?: boolean,
    visible: boolean,
    onCreated: () => void
    onCancel: () => void,
}

const dispatch = store.dispatch;
const NewGroupModal = (Props: Props) => {
    const [form] = Form.useForm();
    const [api, contextHolder] = notification.useNotification();
    const createdGroup = useSelector((state: any) => state.createdGroup);
    const actorTypesState = useSelector((state: any) => state.actorTypes);
    return (
        <Modal
            width={800}
            visible={Props.visible}
            title={'Grupo de investigación'}
            okText={'Agregar'}
            cancelText="Cancelar"
            footer={null}
            onCancel={Props.onCancel}
        >
            <>
                {contextHolder}
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={async (formData: any) => {
                        form.validateFields().then(async (values: any) => {
                            await dispatch(create({
                                    fcreacion_pd: new Date().toISOString(),
                                    contact_name: values.contact_name,
                                    contact_email: values.contact_email,
                                    nme_clasificacion_gr: values.nme_clasificacion_gr,
                                    nme_municipio_gr:  values.city,
                                    nme_gran_area_gr: values.nme_gran_area_gr,
                                    nme_area_gr: values.nme_area_gr,
                                    nme_area_esp_gr: values.nme_area_esp_gr,
                                    cod_grupo_gr: values.cod_grupo_gr,
                                    nme_grupo_gr: values.nme_grupo_gr,
                                    description: values.description,
                                    actor_type:actorTypesState.list.find((c:any)=>c.collection_name === Actor.ResearchGroup).id,
                                    recognized_min: values.recognized_min.value,
                                    update_date: new Date(values.update_date).toISOString(),
                                    issue_date: new Date(values.issue_date).toISOString(),
                                    current_date: new Date(values.current_date).toISOString(),
                                    features: values.features,
                                    source: values.source,
                                    city: values?.city,
                                    url: values.url,
                                    universities : values?.universities?.map((e: any) => ({ universities_id: e.value })) || [],
                                    codigo_institucion: []
                                }));

                                Props.onCreated();
                        });
                    }}
                    name="newGroup"
                >
                    <Row gutter={[8, 8]} style={{ width: '100%', marginTop: 30 }}>
                        <Col xs={24} sm={12} md={8} lg={18}>
                            <Form.Item
                                label="Grupo"
                                name="nme_grupo_gr"
                                rules={[
                                    { required: true, message: 'Por favor ingrese el nombre del grupo' },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={6}>
                            <Form.Item
                                label="Código de grupo"
                                name="cod_grupo_gr"
                                rules={[
                                    { type: 'string',  message: 'Por favor ingrese el código del grupo' },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={24}>
                            <Form.Item
                                label="Descripción"
                                name="description"
                                rules={[
                                    { type: 'string' },
                                ]}
                            >
                                <Input.TextArea />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={12}>
                            <Form.Item
                                label="Nombre de contacto"
                                name="contact_name"
                                rules={[
                                    { required: true, message: 'Por favor ingrese el nombre de contacto' },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={12}>
                            <Form.Item
                                label="Email de contacto"
                                name="contact_email"
                                rules={[
                                    { required: true, message: 'Por favor ingrese el email de contacto' },
                                    { type: 'email', message: 'Por favor ingrese un email válido' },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={24}>
                            <Form.Item
                                label="Institución"
                                name="universities"
                                rules={[
                                    { type: 'array' },
                                ]}
                            >
                                <SelectUniversity
                                    onClear={() => {

                                    }}
                                    mode={'multiple'}
                                    style={{ width: '100%' }}
                                    size="large"
                                    onChange={(selected: any) => {
                                        form.setFieldValue('universities', selected);
                                    }}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={12}>
                            <Form.Item
                                label="Clasificación"
                                name="nme_clasificacion_gr"
                                rules={[
                                    { type: 'string' },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col xs={24} sm={12} md={6} lg={12}>
                            <Form.Item
                                label="Ciudad"
                                name="city"
                            >
                                <SelectCities style={{ width: '100%' }} size="large"
                                    defaultValue='Ciudad'
                                    onChange={(selected: any) => {
                                        form.setFieldValue('city', selected.value);
                                    }}
                                    onClear={() => {

                                    }}
                                />
                            </Form.Item>

                        </Col>
                        <Col xs={24} sm={12} md={8} lg={8}>
                            <Form.Item
                                label="Area general"
                                name="nme_area_gr"
                            >
                                <SelectKnowledgeArea
                                    onClear={() => {

                                    }}
                                    style={{ width: '100%' }}
                                    size="large"
                                    defaultValue='Área general'
                                    onChange={(selected: any) => {
                                        form.setFieldValue('nme_area_gr', selected.value);
                                        console.log("selects", selected.value)
                                    }} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={8}>
                            <Form.Item
                                label="Área específica"
                                name="nme_area_esp_gr"
                            >
                                <SelectKnowledgeSpecialty
                                    onClear={() => {
                                    }}
                                    size="large"
                                    defaultValue='Área específica'
                                    onChange={(selected: any) => {
                                        form.setFieldValue('nme_area_esp_gr', selected.value);
                                    }} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={8}>
                            <Form.Item
                                label="Gran área del conocimiento"
                                name="nme_gran_area_gr"
                            >
                                <SelectKnowledgeGran onClear={() => {

                                }} style={{ width: '100%' }}
                                    size="large"
                                    defaultValue='Gran Área de conocimiento'
                                    onChange={(selected: any) => {
                                        form.setFieldValue('nme_gran_area_gr', selected.value);
                                    }} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={6} lg={12}>
                            <Form.Item
                                label="Reconocimiento Min."
                                name="recognized_min"
                                rules={[
                                    { type: 'object', required: true, message: "El campo es obligatorio" },
                                ]}
                            >
                                <SelectRecognition
                                    onClear={() => { }}
                                    size="large"
                                    onChange={async (selected: any) => {
                                        if (selected) {
                                            form.setFieldValue('recognized_min', selected);
                                        }
                                    }} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={12}>
                            <Form.Item
                                label="Fuente"
                                name="source"
                                rules={[
                                    { type: 'string', required: true, message: "El campo es obligatorio" }
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={24}>
                            <Form.Item
                                label="Características"
                                name="features"
                                rules={[
                                    { type: 'string' },
                                ]}
                            >
                                <TextArea rows={4} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={8}>
                            <Form.Item
                                label="Fecha de expedición"
                                name="issue_date"
                                rules={[
                                    { type: 'object', required: true, message: "Ingrese una fecha valida" },
                                ]}
                            >
                                <DatePicker
                                    placeholder='Fecha de expedición'
                                    format={'YYYY-MM-DD'}
                                    onChange={(date, dateString) => form.setFieldValue('issue_date', date)}
                                    style={{ width: '100%' }}
                                    size='large' />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={8}>
                            <Form.Item
                                label="Vigencia"
                                name="current_date"
                                rules={[
                                    { type: 'object', required: true, message: "Ingrese una fecha valida" },
                                ]}
                            >
                                <DatePicker
                                    format={'YYYY-MM-DD'}
                                    onChange={(date, dateString) => form.setFieldValue('issue_date', date)}
                                    style={{ width: '100%' }}
                                    size='large'
                                    placeholder='Vigencia'
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={8}>
                            <Form.Item
                                label="Última actualización"
                                name="update_date"
                                rules={[
                                    { type: 'object', required: true, message: "Ingrese una fecha valida" },
                                ]}
                            >
                                <DatePicker
                                    format={'YYYY-MM-DD'}
                                    onChange={(date, dateString) => form.setFieldValue('issue_date', date)}
                                    style={{ width: '100%' }}
                                    size='large'
                                    placeholder='Última actualización'
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item wrapperCol={{ span: 24 }}>
                        <Button
                            loading={createdGroup?.isLoading}
                            type="primary"
                            size={"large"}
                            block
                            htmlType="submit"
                        >
                            Agregar grupo
                        </Button>
                    </Form.Item>
                </Form>
            </>
        </Modal>
    );
};

export default NewGroupModal;
